import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // --- GA Dashboard visit ---
    window.analytics?.trackEvent("dashboard_visit");
  }

  addForm(e) {
    e.preventDefault();
    document.getElementsByClassName("transaction-form")[0].classList.remove("d-none");
    document.getElementsByClassName("reset-button")[0].classList.add("d-none");
  }

  validationForForm(e) {
    e.preventDefault();
    const alert = document.getElementById("reset_alert");
    const form = document.getElementById("new_payment_transaction");
    if (this.invalidInputs() > 0) {
      alert.classList.remove("d-none");
      this.scrollToTop();
      return 0;
    } else {
      alert.classList.add("d-none");
      form.submit();
    }
  }

  enableSubmitButton() {
    document.getElementById("submitButton").disabled = false;
  }

  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  invalidInputs() {
    const invalidFields = [];
    document.querySelectorAll("input.required, input[id=\"payment_transaction_contracts_deposit_gold_weight\"], input[id=\"payment_transaction_contracts_delivered_gold_weight\"]").forEach(function (field) {
      if (field.offsetParent !== null && (field.value === "")) {
        field.classList.add("is-invalid");
        invalidFields.push(field);
      } else {
        field.classList.remove("is-invalid");
      }
    });
    return invalidFields.length;
  }
}
